import { css } from '@emotion/css';
import { Headline, Headline2 } from '@volumental/common';
import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { uiConfig } from '../../../services/config';

const imgStyle = css`
  max-width: 56px;
  max-height: 56px;
  flex-shrink: 1;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  background-color: white;
`;

const rowStyle = css`
  display: flex;
  flex-direction: row;
  padding: 24px 0px;
  justify-content: space-between;
`;

const columnStyle = css`
  display: flex;
  flex-direction: column;
  justify-content: left;
  text-align: left;
`;

const titleStyle = (mode: 'recommendation' | 'sizeguide'): string => css`
  font-weight: ${uiConfig.styles.fontWeights.regular};
  max-lines: 1;
  overflow: hidden;
  line-height: normal;
  font-size: ${mode === 'recommendation' ? '16px' : '32px'};
  margin: auto;
  margin: auto 0 auto 0;
`;

const productStyle = (mode: 'recommendation' | 'sizeguide'): string => css`
  font-weight: ${mode === 'recommendation'
    ? uiConfig.styles.fontWeights.bold
    : uiConfig.styles.fontWeights.regular};
  max-lines: 1;
  overflow: hidden;
  line-height: normal;
  font-size: ${mode === 'recommendation' ? '21px' : '14px'};
  margin: 0;
`;

interface PDetailsProps {
  imageSrc?: string;
  displayName: string;
  title: string;
  mode: 'recommendation' | 'sizeguide';
}
export function ProductDetails({
  imageSrc,
  displayName,
  mode,
  title,
}: PDetailsProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className={rowStyle}>
      <div className={columnStyle}>
        <Headline className={titleStyle(mode)}>{title}</Headline>
        <Headline2 className={productStyle(mode)}>{displayName}</Headline2>
      </div>
      {imageSrc && (
        <img
          src={imageSrc}
          role="presentation"
          alt={t('imageAlt.productImage')}
          className={imgStyle}
        />
      )}
    </div>
  );
}
